import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
import PortalVue from 'portal-vue'

import jQuery from 'jquery'
if (!window.jQuery) {
  window.$ = window.jQuery = require("jquery");
}

Vue.use(PortalVue)
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  // template,
  render: h => h(App),
}).$mount('#locationFinder')
